<template>
  <v-container class="agents-table-list">
    <v-row class="agents-top-table mb-2">
      <v-col
        class="agents-count pr-0"
        align-self="center"
        cols="12"
        md="8"
        sm="8"
      >
        <p class="mb-0 display-24 font-weight-medium">
          הסוכנים החכמים שלי ({{ activeAgents || 0 }})
        </p>
      </v-col>
      <v-col class="text-left px-0 py-0" cols="12" md="4" sm="4">
        <v-btn
          :to="'/smartalerts.aspx'"
          color="primary"
          rounded
          :width="$vuetify.breakpoint.smAndUp ? '' : '100%'"
          class="add-agent"
        >
          הוספת סוכן חכם חדש
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-for="(agent, index) in agents" :key="index + 'agent'">
      <AgentItem
        :agentStatus="agent.Active"
        :agentCode="agent.AgentCode"
        :index="index"
      >
        <template v-slot:name>
          <span>{{ agent.AgentName }}</span>
        </template>
      </AgentItem>
    </v-row>
    <InstructionsAgentsRemove :showTour="showAgentsRemove" />
  </v-container>
</template>

<script>
import AgentItem from '@/components/Japu/AgentItem';
import CurrentUser from '@/components/mixins/CurrentUser';
import InstructionsAgentsRemove from '@/components/Japu/Instructions/InstructionsAgentsRemove';

export default {
  mixins: [CurrentUser],
  components: { AgentItem, InstructionsAgentsRemove },
  props: {
    agentsData: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    agents() {
      const arr = this.agentsData.ResultList;
      // const newArr = [
      //   ...arr.filter((c) => c.Active === true),
      //   ...arr.filter((c) => c.Active === false),
      // ].reverse();

      return arr;
    },
    activeAgents() {
      if (this.CurrentUser) {
        return this.ActiveAgents.length;
      } else {
        return 0;
      }
    },
  },
  data() {
    return { showAgentsRemove: null };
  },
  mounted() {
    this.currentRouteFromEmail();
  },
  methods: {
    currentRouteFromEmail() {
      let query = this.$route.query;
      let fromEmail = query && query.sct && query.utm_campaign ? true : false;
      if (fromEmail) this.showAgentsRemove = !this.showAgentsRemove;
    },
  },
};
</script>
